import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Snackbar, Box, CircularProgress, Typography } from "@mui/material";
import { useStateValue } from "../../contexto/store";
import { obtenerUsuarioActual } from "../../actions/UsuarioAction";

// ─── Splash Screen ────────────────────────────────────────────────────────────
// Shown while the app verifies the stored token and hydrates the session state.
const AppSplashScreen = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      gap: 2,
      background: 'linear-gradient(135deg, #F5F7FA 0%, #E0F2F1 100%)',
    }}
  >
    <CircularProgress size={48} thickness={3} color="primary" />
    <Typography variant="h6" color="primary.main" fontWeight={700} letterSpacing={1}>
      AGUA POTABLE
    </Typography>
    <Typography variant="body2" color="text.secondary">
      Verificando sesión...
    </Typography>
  </Box>
);

const RootLayout = () => {
  const [{ openSnackbar }, dispatch] = useStateValue();
  const [iniciaApp, setIniciaApp] = useState(false);

  useEffect(() => {
    if (!iniciaApp) {
      obtenerUsuarioActual(dispatch)
        .then(() => setIniciaApp(true))
        .catch(() => setIniciaApp(true));
    }
  }, [iniciaApp, dispatch]);

  // Show a branded splash screen while the session is being verified
  if (!iniciaApp) return <AppSplashScreen />;

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={openSnackbar ? openSnackbar.open : false}
        autoHideDuration={3000}
        slotProps={{ content: { "aria-describedby": "message-id" } }}
        message={<span id="message-id">{openSnackbar ? openSnackbar.mensaje : ""}</span>}
        onClose={() =>
          dispatch({
            type: "OPEN_SNACKBAR",
            openMensaje: { open: false, mensaje: "" },
          })
        }
      />
      <Outlet />
    </>
  );
};

export default RootLayout;

